import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/adjustment_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  adjustable_of_SalesOrder_type_id_eq: {
    model_name: 'SalesOrder',
    column_type: 'string',
    column_name: 'id',
  },
  creator_id_eq: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Adjustment',
  },
  creator: {
    column_type: 'belongs_to',
    column_name: 'creator',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Adjustment',
  },
}
export const formColumnsConfig = {
  'self': {
    'amount': { required: true, disabledUpdate: false },
    'adjustable_id': { required: true, disabledUpdate: false },
    'adjustable_type': { required: true, disabledUpdate: false },
    'remark': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Adjustment', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Adjustment', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
